import { openUrl } from '@/common/bridge/openUrl';
import { getDomain, getEnv, getKrnDomain } from '@/common/api';
import queryString from 'query-string';
import { logClickGuarantee } from './logger2.0';
import { useExtParamsObject } from './content/utils';
import { logClickCartEnter, TCartMarketingParams, onCartRightCornerEnter } from './logger2.0';
import yoda from '@kibt/bridge';
import { isAndroid, isIOS } from '@kibt/krn-utils';
import { appVersion, isWeb } from '@/common/device-info';
import { delay } from '@/utils/delay';
import { modifyUrlWithParams } from '@/common/utils/modifyUrlWithParams';
import { useQuery } from '@/hooks/useQuery';
import { versionCompare } from '@kibt/web-utils/version';
import { useDebounceFn } from 'ahooks';
import { useDetailPageStore } from '../store';
import { SHELF_QUERY_KEY } from '@/utils/shelfSource';
import { getQuery } from '@/common/const';
import { SCENE } from '@/common/const';
import { useParams } from 'react-router';
import { GgPixelEnum, googlePixelLog } from '@/common/pixel';

/**
 *
 * 跳转krn页面
 */

// const extParams = getExtParams();
// 给callapp使用
export const useDetailPageUrl = () => {
    const { itemId } = useDetailPageStore(s => ({
        itemId: s.itemId,
    }));
    const source = useQuery('source') as string;
    const extParamsObj = useExtParamsObject();
    const extParamsEncoded = `${encodeURIComponent(JSON.stringify(extParamsObj))}`;
    const env = getEnv();
    const sellerUserId = useQuery('sellerUserId') || 0;
    const photoId = (useQuery('photoId') as string) || '';
    const h5Url = `${getKrnDomain()}/krn-web/detail.html?&extParams=${extParamsEncoded}&sellerUserId=${sellerUserId}&__launch_options__=%7B%22enableLoading%22%3Afalse%2C%22topBarPosition%22%3A%22fixed%22%7D&hyId=kibt-fe-shop-c-krn`;
    const krnUrl = queryString.stringify(
        {
            bundleId: 'Detail',
            componentName: 'Detail',
            item: itemId,
            source: source,
            photoId,
            themeStyle: 1,
        },
        { sort: false }
    );
    const url = queryString.stringifyUrl(
        {
            url: h5Url,
            query: {
                redirectUrl: krnUrl,
                source: source,
                env,
                itemId,
                photoId,
            },
        },
        { skipEmptyString: true, skipNull: true }
    );
    // console.log('getDetailPageUrl', url);
    return url;
};

export function useJumpToCart() {
    const extParamsObj = useExtParamsObject();

    // 跳转到购物车 TODO:
    // feat-url-dispatch 小黄车跳购物车
    const jumpToCart = async (param?: {
        halfWebview?: boolean;
        addressId?: number;
        red_point_num?: number;
        params?: TCartMarketingParams;
        position?: 'right-coner' | 'default';
        backendDispatchUrl?: string;
    }) => {
        // 未登陆需要登陆
        const res = await yoda.component.login({});
        const { halfWebview = false, addressId, red_point_num, params, position, backendDispatchUrl } = param || {};
        if (res && +res.result === 1) {
            if (!position || position === 'default') logClickCartEnter(red_point_num, params);
            if (position === 'right-coner') onCartRightCornerEnter(red_point_num, params);

            const krnUrl = queryString.stringify(
                {
                    bundleId: 'MyShoppingCar',
                    componentName: 'MyShoppingCar',
                    env: getEnv(),
                    cornerRadius: 16,
                    addressId: addressId || '',
                },
                { sort: false }
            );
            const query = {
                redirectUrl: krnUrl,
                env: getEnv(),
                addressId: addressId || '',
                extParams: JSON.stringify(extParamsObj),
                __launch_options__: JSON.stringify({
                    enableLoading: false,
                    topBarPosition: 'fixed',
                }),
                hyId: 'kibt-fe-shop-c-krn',
                krnFollowParams: 1,
            };
            const url = queryString.stringifyUrl(
                {
                    url: `${getKrnDomain()}/krn-web/my-shopping-car`,
                    query,
                },
                { skipEmptyString: true, skipNull: true }
            );
            console.log('jumpToCart', url);
            const jumpUrl = backendDispatchUrl ? modifyUrlWithParams(backendDispatchUrl, { ...query }, ['redirectUrl']) : '';
            return openUrl({ url, halfWebview }, { url: jumpUrl });
        }
    };
    return { jumpToCart };
}

export function useJumpToConfirmOrder() {
    const clickid = getQuery('click_id') || '';
    const scene = getQuery('scene');
    const extParams = useExtParamsObject();
    const detailStore = useDetailPageStore();
    // 跳转到提单页，在 URL 新增 inp 参数
    const { run: jumpToConfirmOrder } = useDebounceFn(
        async ({
            addressId,
            buyamount,
            merchantId,
            skuId,
            itemId,
            sellerMerchantId,
            sellerUserId,
            poc,
            needDelay,
            flashSaleActivityId,
            minPurchase,
            halfWebview = false,
            retrievalInfo = undefined,
            extParamsCustom = undefined,
            backendDispatchUrl = '',
            promotionId = undefined,
            afterDiscountPrice = undefined,
            toSpecBuy = false,
            firstSpecValueId = '',
            specBuyUuid = null,
            pageRawData,
            channel = 0,
            scene: sceneFromParam,
        }) => {
            const _pageRawData = pageRawData || detailStore.getState().pageRawData;
            //活动类型: 提单页统一叫marketingType, marketingId字段，这里做下映射
            const hotItemFlashParams = _pageRawData?.activityInfo?.marketingActivityType
                ? {
                      marketingType: _pageRawData?.activityInfo?.marketingActivityType,
                      marketingId: _pageRawData?.activityInfo?.activityId,
                  }
                : {};
            const productItems = [
                {
                    itemId,
                    merchantId,
                    num: buyamount,
                    skuId,
                    flashSaleActivityId,
                    needProductSpec: toSpecBuy,
                    ...hotItemFlashParams,
                    ...(promotionId
                        ? {
                              distributorDiscount: {
                                  // 达人补贴的活动id
                                  promotionId,
                                  afterDiscountPrice: {
                                      amount: afterDiscountPrice,
                                  },
                              },
                          }
                        : {}),
                },
            ];
            const productItemListStr = `${encodeURIComponent(JSON.stringify(productItems))}`;
            // 合并当前链接取的来源与自定义传入的来源
            const finalExtParams = Object.assign({}, extParams, extParamsCustom);
            const retrievalInfoEncoded = `${encodeURIComponent(JSON.stringify(retrievalInfo))}`;
            const halfWebviewParams =
                halfWebview || toSpecBuy
                    ? {
                          cornerRadius: 16,
                          height: 1, // iosrn 新增跳转参数
                          foldRatio: 0.95, // iosrn 新增跳转参数
                          openSlideFullScreen: 0, // iosrn 新增跳转参数 表明是可拖拽的半屏
                          isHalf: 1, // iosrn 新增跳转参数
                      }
                    : {};
            // 1元申样订单 新增一个参数，反正， 不动原有结构
            const channelParam = channel === 1 ? { channel: 1 } : {};
            const krnUrl = queryString.stringify(
                {
                    click_id: clickid,
                    bundleId: 'EcommOrderConfirm',
                    componentName: toSpecBuy ? 'SpecBuy' : 'OrderConfirm',
                    env: getEnv(),
                    productItems: productItemListStr,
                    buyamount,
                    ...channelParam,
                    merchantId,
                    skuId,
                    itemId,
                    sellerMerchantId,
                    firstSpecValueId,
                    needProductSpec: toSpecBuy,
                    sellerUserId,
                    // extParams: extParamsEncoded,
                    extParams: JSON.stringify(finalExtParams),
                    minPurchase,
                    retrievalInfo: retrievalInfoEncoded,
                    promotionId,
                    afterDiscountPrice,
                    forPromotionId: promotionId ? '1' : undefined,
                    ...halfWebviewParams,
                    scene: SCENE.PRODUCT_DETAIL_OUTSIDE_WEB,
                },
                { sort: false }
            );
            const query = {
                click_id: clickid,
                krnFollowParams: 1,
                referer_page: poc,
                addressId: addressId || '',
                productItems: JSON.stringify(productItems),
                buyamount,
                ...channelParam,
                minPurchase,
                merchantId,
                skuId,
                firstSpecValueId,
                itemId,
                promotionId,
                afterDiscountPrice,
                forPromotionId: promotionId ? '1' : undefined,
                sellerMerchantId,
                specBuyUuid,
                sellerUserId,
                extParams: JSON.stringify(finalExtParams),
                __launch_options__: JSON.stringify({
                    enableLoading: false,
                    topBarPosition: 'fixed',
                }),
                hyId: 'kibt-fe-shop-c-krn',
                componentName: toSpecBuy ? 'SpecBuy' : 'OrderConfirm',
                retrievalInfo: retrievalInfoEncoded,
                redirectUrl: krnUrl,
                scene: SCENE.PRODUCT_DETAIL_OUTSIDE_WEB,
            };
            const url = queryString.stringifyUrl(
                {
                    url: `${getKrnDomain()}/krn-web/order-confirm`,
                    query,
                },
                { skipEmptyString: true, skipNull: true }
            );
            const jumpUrl = backendDispatchUrl ? modifyUrlWithParams(backendDispatchUrl, { ...query }, ['merchantId', 'redirectUrl']) : '';
            googlePixelLog(GgPixelEnum.ORDER_CONFIRM_SUCCESS);
            return openUrl(
                {
                    url,
                    halfWebview: !!halfWebview || toSpecBuy,
                    options: { showMask: toSpecBuy ? true : false, fullScreen: '0' },
                    isNeedSetTimeout: true,
                    refererPage: 'Detail_' + poc,
                    height: 0.95,
                },
                { url: jumpUrl }
            );
        },
        {
            leading: true,
            trailing: false,
            wait: 300,
        }
    );

    return { jumpToConfirmOrder };
}

/**
 *
 * 跳转h5页面
 */

// 跳转到新增地址
export const jumpToAddressHalfAddPage = itemId => {
    const url =
        getDomain() +
        `/shop/c/address-half/add?itemId=${itemId}&__launch_options__=${encodeURIComponent(
            JSON.stringify({
                enableLoading: false,
                topBarPosition: 'fixed',
            })
        )}`;
    openUrl({ url });
};

// 跳转到shelf地址
export const jumpToShlef = (shelfSourceQueryString?: string) => {
    const url = queryString.stringifyUrl(
        {
            url: getDomain() + '/shop/c/distribute/shelf',
            query: {
                hyId: 'kibt-fe-shop-c-v1',
                __launch_options__: JSON.stringify({
                    topBarPosition: 'fixed',
                }),
                [SHELF_QUERY_KEY]: shelfSourceQueryString,
            },
        },
        { skipEmptyString: true, skipNull: true }
    );
    openUrl({ url });
};

// 跳转到平台担保服务页面
export const onShowGuaranteeV0 = (itemId, isHalfWebview = false) => {
    logClickGuarantee(itemId, isHalfWebview);
    const url =
        getDomain() +
        `/shop/c/detail/guarantee?hyId=kibt-fe-shop-c-v1&__launch_options__=${encodeURIComponent(
            JSON.stringify({
                enableLoading: false,
                topBarPosition: 'fixed',
            })
        )}&formKrn=1`;
    openUrl({ url });
};

// 跳转到平台担保服务页面
export const onShowGuaranteeV1 = (itemId = 0, isHalfWebview = false, serverTab = 'SERVICE_GUARANTEE') => {
    onShowGuaranteeV0(itemId, isHalfWebview);
};

/**
 * @deprecated 此页面已废弃，全部跳转到RN支付保障页面 @liuhe
 */
export const onShowReturnGuarantee = () => {
    const url =
        getDomain() +
        `/shop/c/detail/return-guarantee?hyId=kibt-fe-shop-c-v1&__launch_options__=${encodeURIComponent(
            JSON.stringify({
                enableLoading: false,
                topBarPosition: 'fixed',
            })
        )}&formKrn=1`;
    openUrl({ url });
};

// 跳转到优惠券详情页
export const goToCouponDetail = couponInfo => {
    const { couponId, batchId } = couponInfo;
    const url =
        getDomain() +
        `/shop/c/coupon/detail?couponId=${couponId}&batchId=${batchId}&__launch_options__=${encodeURIComponent(
            JSON.stringify({
                topBarPosition: 'fixed',
            })
        )}&couponInfo=${encodeURIComponent(JSON.stringify(couponInfo))}`;
    openUrl({ url });
};

// 联系卖家 todo 原h5版本写法如下 询问军乐 那些localStorage是干嘛的
export const jumpToContactMerchant = (pageRawDate, merchantId, itemId) => {
    // logClickOrderContactSeller(orderId);
    const _url =
        getDomain() +
        `/shop/c/shop-service/shopmes?hyId=kibt-fe-shop-c-v1&showUnread=false&curMerchanId=${merchantId}&itemId=${itemId}&pageFrom=itemDetail&__launch_options__=${encodeURIComponent(
            JSON.stringify({
                topBarPosition: 'fixed',
            })
        )}`;
    const url = queryString.stringifyUrl({
        url: _url,
        query: {
            'un-send-card-data': JSON.stringify({
                commodityId: pageRawDate.itemId,
                commodityTitle: pageRawDate.title,
                commodityCoverImageUrl: pageRawDate.imageUrls[0],
                commodityPrice: pageRawDate.displayItemPrice,
                commodityStock: pageRawDate.displayTotalQuantity,
                commoditySaleCount: pageRawDate.displayTotalSoldQuantity,
            }),
            formKrn: 1,
        },
    });
    openUrl({ url });
};

// const onContactMerchant = () => {
//     window.localStorage.setItem('un-send-card-data', JSON.stringify(
//         {
//             orderId: state.orderId,
//             orderStatus: state.orderStatus,
//             // 不需要暂时就传0
//             orderAftersaleType: state.orderDetail!.aftersaleInfo?.aftersaleType || 0,
//             orderConsultType: state.orderDetail!.aftersaleInfo?.consultType || 0,
//             orderCommodityCoverImageUrl: state.orderDetail!.subOrderList[0].imageUrl,
//             orderPaymentAmount: state.orderDetail!.subOrderList[0].displayTotalPrice,
//             orderCommodityTitle: state.orderDetail!.subOrderList[0].title,
//             orderCommodityNumber: state.orderDetail!.subOrderList[0].skuQuantity,
//             orderAftersaleStatus: state.orderDetail!.aftersaleStatusView || 0,
//         }
//     ));

//     invokeYoda('webview', 'open', {
//         url: `${window.location.origin}/shop/c/shop-service/shopmes?&hyId=kibt-fe-shop-c-v1&showUnread=false&curMerchanId=${(state.orderDetail as any).merchantId}&itemId=${state.currentItem.itemId}&pageFrom=orderDetail`,
//         launchOptions: {
//             topBarPosition: 'fixed', // 隐藏导航栏
//         },
//     }).catch(() => {
//         router.push({
//             path: '/shop/c/shop-service/shopmes?__launch_options__=%7B"enableLoading"%3Afalse,"topBarPosition"%3A"fixed"%7D&hyId=kibt-fe-shop-c-v1&adjustKeyboard=true',
//             query:{
//                 curMerchanId: (state.orderDetail as any).merchantId,
//                 showUnread: 'false',
//                 itemId: state.currentItem.itemId,
//                 pageFrom: 'orderDetail',
//             },
//         });
//     });
//     clickOrderContactSeller(orderId);
// };
